var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        fullscreen: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pa-0" },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.Close()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Cadastro Empresa Grupo")]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", text: "", disabled: !_vm.valid },
                          on: {
                            click: function ($event) {
                              return _vm.Salvar()
                            },
                          },
                        },
                        [_vm._v("Salvar")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "10", md: "10", lg: "10" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nome",
                              rules: _vm.fieldRules,
                              counter: 100,
                              maxlength: "100",
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.nome,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "nome", $$v)
                              },
                              expression: "item.nome",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "2", md: "2", lg: "2" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.ativoEnum,
                              "item-text": "nome",
                              "item-value": "id",
                              label: "Situação",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.situacao,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "situacao", $$v)
                              },
                              expression: "item.situacao",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }